import { StyleSheet, View } from "react-native";
import React from "react";

//Custom Imports
import color from "@constants/color";
import Text from "@components/CustomText";
import { UpcomingDates } from "./UpcominngLeave";
import SmallPaidIcon from "@assets/svg/Vacation/SmallPaidIcon";
import SmallUnpaidIcon from "@assets/svg/Vacation/SmallUnpaidIcon";
import t from "@constants/localization";
import { getHardDayMonth } from "@utils/getFormattedDate";
const PATH = "screens/Vacation/index";

const ShowPaidUnpaidLeave = ({ title = "", data = [], iconName = "" }) => {
  return (
    <View style={styles.paidUnpaidContainer}>
      <View style={styles.iconTitleContainer}>
        {iconName === "paid" ? <SmallPaidIcon /> : <SmallUnpaidIcon />}
        <Text style={styles.paidText} variant="body_text_1" newfont={true}>
          {title}
        </Text>
      </View>
      <View style={styles.showDateContainer}>
        {data.map((item, index) => (
          <UpcomingDates
            backgroundColor={"rgba(0, 0, 0, 0.05)"}
            textColor={"rgba(0, 0, 0, 0.36)"}
            date={getHardDayMonth(item?.vacation_date)}
            borderColor={"rgba(0, 0, 0, 0.1)"}
            isEdit={false}
            style={styles.unpaidLeave}
            key={`${index}${item?.vacation_date}`}
          />
        ))}
      </View>
    </View>
  );
};

const PreviousVacation = ({
  navigation,
  past_paid_leaves = [],
  past_unpaid_leaves = [],
}) => {
  return (
    <View style={styles.container}>
      <Text style={styles.titleText} variant="entityHeading" newfont={true}>
        {t(`${PATH}/previousLeaves`)}
      </Text>
      {past_paid_leaves.length !== 0 && (
        <ShowPaidUnpaidLeave
          title={t(`${PATH}/paidLeave`)}
          data={past_paid_leaves}
          iconName={"paid"}
        />
      )}
      {past_unpaid_leaves.length !== 0 && (
        <ShowPaidUnpaidLeave
          title={t(`${PATH}/unpaidLeave`)}
          data={past_unpaid_leaves}
          iconName={"unpaid"}
        />
      )}
    </View>
  );
};

export default PreviousVacation;

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 16,
    marginTop: 40,
  },
  titleText: {
    marginBottom: 0,
    paddingHorizontal: 0,
  },
  paidUnpaidContainer: {
    backgroundColor: color.white,
    borderRadius: 8,
    marginTop: 12,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.1)",
    paddingVertical: 16,
  },
  iconTitleContainer: {
    flexDirection: "row",
    marginHorizontal: 16,
  },
  paidText: {
    marginStart: 8,
  },
  showDateContainer: {
    flexGrow: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    marginStart: 4,
    marginEnd: 16,
  },
  unpaidLeave: {
    marginStart: 12,
    marginTop: 12,
  },
});
